"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewHoldConfigModel () {
        return ReviewHoldConfigModel;
    },
    get ReviewHoldPhase () {
        return ReviewHoldPhase;
    },
    get ReviewHoldPlacementModel () {
        return ReviewHoldPlacementModel;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ReviewHoldPhase = _zod.default.enum([
    "authors",
    "signers"
]);
const ReviewHoldPlacementModel = _zod.default.object({
    phase: ReviewHoldPhase,
    index: _zod.default.number().int().nonnegative()
});
const ReviewHoldConfigModel = _zod.default.object({
    enabled: _zod.default.boolean(),
    placement: ReviewHoldPlacementModel
});
